import { useEffect } from 'react';
import {
  FixedGrid,
  itemInGrid,
} from 'MonadomCoreUI';
import { useGlobalStateSelector, words } from './globalState';
import {
  handleClickGoTop,
} from './monadomCore';

// CARD LIST
function CardList() {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const navigate = useGlobalStateSelector(({ navigate }) => navigate);

  useEffect( () => {
    const urlParams = (new URL(document.location)).searchParams;
    const asset = urlParams.get('asset');

    if (state.registeredCard[asset] !== undefined) {
      let type;

      if (window.innerWidth >= 832) {
        type = 'monsterDetail';
      }
      else {
        type = 'itemDetailSP';
      }

      const body = {
        card: {
          asset: asset, 
        },
        actionBox: 'close',
      };

      const popup = { type: type, body: body };
      dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: popup });
    }
  }, [state.registeredCard]);

  let items =
   Object.values(state.registeredCard)
  .sort( (a, b) => a.cardNo - b.cardNo )
  // .map ( item => <Item item={item} size='small' quantity={false} arrows={false} />);

  const headerFixed =
  <div className='z200FixedZero widthMax backgroundColorWhiteTransparent '>
    <div className='flexRow justifyContentFlexEnd marginBottom1' >
      <button className='button2' onClick={ () => handleClickGoTop(state, dispatch, navigate) }>
        { words.back[state.language] }
      </button>
    </div>
  </div>;

  const headerRelative =
  <div className='widthMax height6 ' >
  </div>;


  return (
    <div>
      {/* PC */}
      <div className="visibleMiddleOrMore flexColumn alignItemsCenter" >
        { headerRelative }
        <div style={{ width: '98vw', height: `calc(98vh - 6em)`, boxSizing: 'border-box' }} > {/* 6emはheaderRelative */}
          <FixedGrid items={items} argToCellFunction={{ boxWidth: '14em', cardWidth: '10em' }} >
            { itemInGrid }
          </FixedGrid>
        </div>
        {/*
          <div className="flexRow justifyContentSpaceAround ">
              { items }
          </div>
        */}
      </div>
      {/* SP */}
      <div className="visibleSmallOrLess flexColumn alignItemsCenter " >
        { headerRelative }
        <div style={{ width: '98vw', height: `calc(98vh - 6em)`, boxSizing: 'border-box' }} > {/* 6emはheaderRelative */}
          <FixedGrid items={items} cellWidth={76} cellHeight={115} argToCellFunction={{ boxWidth: '5.2em', cardWidth: '4em', device: 'sp' }} >
            { itemInGrid }
          </FixedGrid>
        </div>
        {/*
          <div className="flexRow justifyContentSpaceAround">
              { items }
          </div>
        */}
      </div>
      { headerFixed }
    </div>
  );
}

export {
  CardList,
};
